module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "auto"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "dialog-component"
  }, [_c('v-card', [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.replaceWithBr(_vm.cardText))
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    class: _vm.alertColor ? 'secondary-btn alert-color' : 'secondary-btn',
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.secondaryBtnClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.secondaryBtnText) + "\n            ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    class: _vm.alertColor ? 'main-btn alert-color' : 'main-btn',
    on: {
      "click": _vm.mainBtnClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.mainBtnText) + "\n            ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dacc4bbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Dialog.vue
// module id = 1751
// module chunks = 0